var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo8Bit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 28,
    viewBox: "0 0 249 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 27.1546V0.236891H7.69078V11.7731H11.5362V7.92767H15.3816V4.08228H19.2269V0.236891H26.9177V4.08228H23.0723V7.92767H19.2269V11.7731H15.3816V15.6184H19.2269V19.4638H23.0723V23.3092H26.9177V27.1546H15.3816V23.3092H11.5362V19.4638H7.69078V27.1546H0ZM37.531 27.1546V0.236891H64.4487V4.08228H45.2218V11.7731H60.6033V15.6184H45.2218V23.3092H64.4487V27.1546H37.531ZM86.5982 27.1546V15.6184H82.7528V11.7731H78.9074V0.236891H86.5982V11.7731H94.2889V0.236891H101.98V11.7731H98.1343V15.6184H94.2889V27.1546H86.5982ZM112.593 27.1546V0.236891H135.665V4.08228H139.511V11.7731H135.665V15.6184H139.511V23.3092H135.665V27.1546H112.593ZM120.284 11.7731H131.82V4.08228H120.284V11.7731ZM120.284 23.3092H131.82V15.6184H120.284V23.3092ZM153.969 27.1546V23.3092H161.66V4.08228H153.969V0.236891H177.042V4.08228H169.351V23.3092H177.042V27.1546H153.969ZM187.655 27.1546V19.4638H191.5V15.6184H195.346V11.7731H199.191V7.92767H203.037V4.08228H187.655V0.236891H214.573V7.92767H210.727V11.7731H206.882V15.6184H203.037V19.4638H199.191V23.3092H214.573V27.1546H187.655ZM229.031 27.1546V23.3092H232.877V19.4638H236.722V15.6184H240.568V11.7731H236.722V7.92767H232.877V4.08228H229.031V0.236891H236.722V4.08228H240.568V7.92767H244.413V11.7731H248.258V15.6184H244.413V19.4638H240.568V23.3092H236.722V27.1546H229.031Z",
    fill: "url(#paint0_linear_180_44)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_180_44",
    x1: 128,
    y1: 0,
    x2: 128,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#071C36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#143763"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo8Bit);
export default __webpack_public_path__ + "static/media/logo-8bit.29a03beb446a7971863131c46a9d95c3.svg";
export { ForwardRef as ReactComponent };